module.exports = __webpack_public_path__ + "img/sting_20s_novembre_2021.6a712221.jpg";